export default {
  setUserName(state, payload) {
    state.userName = payload;
  },
};
